import { Person } from "@material-ui/icons";
import ApplicationResource from "../../utils/resources.enum";
import UserContextCreate from "./user-context-create";
import UserContextEdit from "./user-context-edit";
import UserContextList from "./user-context.list";

export const userContextResource = {
    name: ApplicationResource.USER_CONTEXTS,
    icon: Person,
    options: { label: "Usuários" },
    link: "/user-contexts",
    tableName: 'user-context',
    list: UserContextList,
    edit: UserContextEdit,
    create: UserContextCreate,
    products: ['school', 'office']
};